











































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { required, helpers } from 'vuelidate/lib/validators';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { currentUserKey } from '@/shared/msw-constants';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import RegexValidators  from '@/shared/regex-validators';

const cssPrefix = 'create-user';
const email = helpers.regex('addressCheck', new RegExp(RegexValidators.email));

@Component({
  components: {
    SwSpinningProgress,
    SwSelect,
    SwIcon,
    SwTextfield,
    SwScrollView,
    SwCheckbox,
    SwButton,
    SwModal,
    SwModalBody,
  },
  validations: {
    inviteUserObj: {
      contactTypeId: { required },
      firstName: {
        required(value: any, vm: any) {
          if (vm?.contactTypeId === '10001') {
            return value !== '';
          }
          return true;
        },
      },
      lastName: {
        required(value: any, vm: any) {
          if (vm?.contactTypeId === '10001') {
            return value !== '';
          }
          return true;
        },
      },
      emailAddress: { required, email },
    },
  },
})
export default class CreateUsersForUserGroup extends SwExtendedVue {
  cssPrefix = cssPrefix;

  inviteUserObj: any = {
    contactTypeId: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
  };
  searchUserQuery: string = '';
  selectedUserList: any = [];
  filterUserData: any = [];
  availableUserList: any[] = [];
  showToaster: boolean = false;
  customerRole: string = '10015';
  contactTypeOptions: SelectOption[] = [
    { id: '10001', label: 'Employee', value: '10001' },
    { id: this.customerRole, label: 'Reseller/Customer', value: this.customerRole },
  ];
  openInviteUserModal: boolean = false;

  isLoadingPartialDataset: boolean = false;
  partialData: any[] = [];

  get computedShowToaster() {
    return this.showToaster;
  }

  get availableUsersForUserGroup() {
    return this.usersForUserGroup?.availbleUsers || [];
  }

  get usersForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getUsersForUserGroup'] || [];
  }

  get selectedUserGroupId() {
    return this.selectedUserGroupDetail[0]?.partyGroupId || '';
  }

  get selectedUserGroupDetail() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroupDetail'] || [];
  }

  get contactTypeTooltip(): TooltipDirValues {
    let content = '';
    content = String(this.$t('modules.userGroups.contentTypeTooltipMssp'));
    return {
      content,
      placement: 'top',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  @Watch('availableUsersForUserGroup', { immediate: true })
  handleAvailableUsersForUserGroup(availableUsers: any) {
    this.availableUserList = availableUsers;
  }

  onChangeContactType() {
    this.showToaster = false;
    if (this.inviteUserObj?.contactTypeId !== '10001') {
      this.inviteUserObj.firstName = '';
      this.inviteUserObj.lastName = '';
    }
  }

  handleSearch() {
    if (this.searchUserQuery) {
      this.availableUserList = this.availableUsersForUserGroup?.filter((list: any) =>
        list?.fullName?.toLocaleLowerCase()?.includes(this.searchUserQuery?.toLowerCase()) ||
        list?.emailAddress?.toLowerCase()?.includes(this.searchUserQuery?.toLowerCase()));
    } else {
      this.availableUserList = this.availableUsersForUserGroup || [];
    }
  }

  onClickInviteUserBtn() {
    this.openInviteUserModal = true;
  }

  onInvite() {
    this.$v?.inviteUserObj?.$touch();
    this.showToaster = this.inviteUserObj?.contactTypeId === '';
    if (!this.$v.$invalid) {
      const emailAlreadyExist = this.availableUserList?.some((user: any) => {
        return user?.emailAddress === this.inviteUserObj?.emailAddress;
      });
      if (emailAlreadyExist) {
        confirmService.confirm({
          status: 'high',
          title: 'Error',
          message: 'This email address already exists.',
          buttons: [{ key: 'ok', name: String(this.$t('common.ok')) }],
        });
      } else {
        const inviteUserPayload: any = {
          ...this.inviteUserObj,
          partyGroupId: this.selectedUserGroupId,
        };
        this.$emit('invite-user', inviteUserPayload);
      }
    }
  }

  getSelectedUsersDetail() {
    return this.availableUserList?.filter((user: any) => this.selectedUserList?.includes(user?.emailAddress))
    ?.map((user: any) => {
      return {
        action: 'add',
        partyGroupId: user?.partyGroupId || this.selectedUserGroupId || '',
        partyId: user?.partyId || '',
      };
    });
  }

  handleAddUsers() {
    this.$emit('selected-users-list', this.getSelectedUsersDetail());
  }

  handleScroll(e: any) {
    if (e.srcElement && (e.srcElement.scrollHeight - e.srcElement.scrollTop - e.srcElement.clientHeight < 1)) {
      this.onLoadMore(20);
    }
  }

  private onLoadMore(minNumToLoad: number) {
    if (this.isLoadingPartialDataset) { return; }
    this.loadData(this.partialData.length, Math.max(minNumToLoad, 20));
  }

  private loadData(start: number, length: number) {
    if (length <= 0) { return Promise.resolve(0); }

    this.isLoadingPartialDataset = true;
    return new Promise<number>((resolve) => {
      setTimeout(
        () => {
          let count = 0;
          for (; count < length && (start + count) < this.filterUserData.length; count += 1) {
            this.partialData.push(this.filterUserData[start + count]);
          }
          this.isLoadingPartialDataset = false;
          resolve(count);
        },
        200,
      );
    });
  }

  created() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles[0] === 'CUSTOMER') {
      this.customerRole = '10015';
    } else {
      this.customerRole = '10006';
    }
    this.searchUserQuery = '';
  }
}
